import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, App } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { authApi } from '@/api/auth';
import { useAuthStore } from '@/store/authStore';

export default function LoginPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const login = useAuthStore((s) => s.login);
  const [loading, setLoading] = useState(false);

  const onFinish = async (values: { email: string; password: string }) => {
    console.log('[LOGIN] Form submit', values);
    setLoading(true);
    try {
      const { data: resp } = await authApi.login(values);
      const { access, refresh, user } = resp.data;
      console.log('[LOGIN] Success', { access, refresh, user });
      login(access, refresh, user);
      message.success(t('auth.loginSuccess'));
      navigate('/');
    } catch (err: any) {
      // Try to show backend error message if available
      const msg = err?.response?.data?.message || t('auth.loginError');
      message.error(msg);
      console.error('[LOGIN] Error', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo">
          <h1>🔧 MyMaintenances</h1>
          <p>{t('app.subtitle')}</p>
        </div>
        <Form layout="vertical" onFinish={onFinish} size="large" autoComplete="off">
          <Form.Item
            name="email"
            rules={[{ required: true, type: 'email', message: t('common.required') }]}
          >
            <Input prefix={<MailOutlined />} placeholder={t('auth.email')} />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: t('common.required') }]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder={t('auth.password')} />
          </Form.Item>
          <Form.Item style={{ marginBottom: 12 }}>
            <Button type="primary" htmlType="submit" loading={loading} block>
              {t('auth.login')}
            </Button>
          </Form.Item>
          <div style={{ textAlign: 'center' }}>
            <Button type="link" onClick={() => navigate('/forgot-password')} style={{ padding: 0 }}>
              {t('auth.forgotPassword')}
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
}
